import { render, staticRenderFns } from "./CalculateSalaryProcessResultForLucaDetail.vue?vue&type=template&id=418c2e34&"
import script from "./CalculateSalaryProcessResultForLucaDetail.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessResultForLucaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports